<template>
  <div class="restore-password-page flex-grow-1">
    <b-container
      class="d-flex justify-content-center align-items-center flex-column h-100"
    >
      <h3 align="center" class="mb-4">Отмена восстановления пароля</h3>

      <b-overlay
        :show="loader"
        rounded="sm"
        variant="white"
        opacity=".35"
        blur="4px"
        class=""
      >
        <template v-if="errorMessage">
          <p>{{ errorMessage }}</p>
        </template>
        <p class="text-center pt-4">
          <router-link to="/login" class="btn btn-link text-secondary"
            >На страницу входа</router-link
          >
        </p>
      </b-overlay>
    </b-container>
  </div>
</template>

<script>
import msg from '@/utils/messages';

export default {
  data() {
    return {
      showForm: false,
      loader: false,
      errorMessage: false
    };
  },
  async mounted() {
    this.errorMessage = false;
    this.loader = true;
    try {
      const token = this.$route.params.t;
      console.log(token);
      const response = await this.$store.dispatch('resetPasswordCancel', token);
      if (response) {
        this.errorMessage = msg.SUCCESS_PASSWORD_RESET_CANCEL;
      }
      this.loader = false;
    } catch (e) {
      this.loader = false;
      this.errorMessage = msg.ERROR_PASSWORD_RESET_CANCEL;
    }
  }
};
</script>

<style lang="scss" scoped>
.restore-password-page {
  background-color: #f5f5f5;
}
</style>
